import { SideBarHeading } from "components";
import type { ReactStoryblokComponent } from "types/storyblok";
import type { SideBarHeadingProps } from "components/SideBarHeading";

const SideBarHeadingAdapter = ({ blok: { text, icon }, sbEditable }: ReactStoryblokComponent<SideBarHeadingProps>) => (
  <SideBarHeading text={text} icon={icon} sbEditable={sbEditable} />
);

export default SideBarHeadingAdapter;
